import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/Field";
import { Brand } from "@/components/AppShell";

export default function SetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) return setError("La password deve avere almeno 8 caratteri");
    if (pwd !== pwd2) return setError("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/set-password", { token: params.get("token") || "", password: pwd });
      toast.success("Password impostata! Ora puoi accedere.");
      nav("/login");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] px-6">
      <form onSubmit={submit} className="card fade-up w-full max-w-md space-y-5" data-testid="set-password-form">
        <Brand />
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight">Imposta la tua password</h1>
          <p className="mt-1 text-sm text-slate-500">Scegli una password di almeno 8 caratteri per la tua area personale.</p>
        </div>
        <Field label="Nuova password"><input type="password" className="field" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="set-password-input" /></Field>
        <Field label="Conferma password"><input type="password" className="field" value={pwd2} onChange={(e) => setPwd2(e.target.value)} data-testid="set-password-confirm-input" /></Field>
        {error && <div className="rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="set-password-error">{error}</div>}
        <button className="btn-primary w-full py-3" disabled={loading} data-testid="set-password-submit">{loading ? "Attendere…" : "Salva password"}</button>
      </form>
    </div>
  );
}
